import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-portal-table-footer',
  templateUrl: './portal-table-footer.component.html',
  styleUrls: ['./portal-table-footer.component.scss'],
})
export class PortalTableFooterComponent {
  @Input() total = 0;
  @Input() pageIndex = 0;
  @Input() pageSize = 10;
  @Input() visibleCount = 0;
  @Input() pageSizeOptions: number[] = [10, 25, 50];
  @Input() rowsLabel = 'Rows per page';

  @Output() pageIndexChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  get offset(): number {
    return this.safePageIndex * this.safePageSize;
  }

  get currentPage(): number {
    return this.safePageIndex + 1;
  }

  get totalPages(): number {
    return Math.max(1, Math.ceil(this.safeTotal / this.safePageSize));
  }

  get pageNumbers(): number[] {
    const start = Math.max(1, Math.min(this.currentPage - 1, this.totalPages - 2));
    const end = Math.min(this.totalPages, start + 2);
    return Array.from({ length: end - start + 1 }, (_item, index) => start + index);
  }

  get from(): number {
    return this.safeTotal ? this.offset + 1 : 0;
  }

  get to(): number {
    return Math.min(this.offset + Math.max(0, this.visibleCount), this.safeTotal);
  }

  private get safeTotal(): number {
    return Math.max(0, this.total || 0);
  }

  private get safePageSize(): number {
    return Math.max(1, this.pageSize || 1);
  }

  private get safePageIndex(): number {
    return Math.min(Math.max(this.pageIndex || 0, 0), this.totalPages - 1);
  }

  setPage(page: number): void {
    const nextPage = Math.min(Math.max(page, 1), this.totalPages);
    this.pageIndexChange.emit(nextPage - 1);
  }

  previousPage(): void {
    this.setPage(this.currentPage - 1);
  }

  nextPage(): void {
    this.setPage(this.currentPage + 1);
  }

  setRowsPerPage(size: number): void {
    this.pageSizeChange.emit(size);
  }

  trackByPage(_index: number, page: number): number {
    return page;
  }
}
